import ProductionTable from "./components/ProductionTable";

const Production = () => {
  return <ProductionTable />;
};

export default Production;
